import { ReactNode, useContext } from 'react';
import { ApplicationContext } from '../../store/context';
import { ErrorView } from '../ErrorView';
import { DataAccessContext } from '@axo/shared/data-access/provider';

interface IError {
  children: ReactNode;
}

export function Error({ children }: IError) {
  const { state } = useContext(ApplicationContext);
  const { state: dataAccessState } = useContext(DataAccessContext);

  if (dataAccessState?.error !== undefined || state?.error !== undefined) {
    return (
      <ErrorView
        title="Something went wrong"
        description={
          dataAccessState.error
            ? dataAccessState.error
            : state.error
            ? state.error
            : ''
        }
      />
    );
  }

  return <>{children}</>;
}
